import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
//List
//Add
import { USZipCodeModel } from "../models/usZipCode/USZipCode";
let USZipCodeModule = /** @class */ (() => {
    var _a, _b;
    let USZipCodeModule = class USZipCodeModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "USZipCode";
            this.usZipCodes = null;
        }
        //View
        async GetAddressByZipCode(zipCode) {
            var url = `${getTenantId()}/${this.apiNode}/` + zipCode;
            let { data } = await service.get(url);
            if (data) {
                this.GetAddress(plainToClass(USZipCodeModel, data.usZipCodes));
                return data;
            }
        }
        //Mutations
        GetAddress(usZipCodes) {
            this.usZipCodes = usZipCodes;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], USZipCodeModule.prototype, "GetAddressByZipCode", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof USZipCodeModel !== "undefined" && USZipCodeModel) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], USZipCodeModule.prototype, "GetAddress", null);
    USZipCodeModule = __decorate([
        Module({ dynamic: true, store: store, name: "usZipCodes", namespaced: true })
    ], USZipCodeModule);
    return USZipCodeModule;
})();
export default getModule(USZipCodeModule);
